module.exports = __webpack_public_path__ + "static/img/twjd-sdo19.668f500.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/twjd-sdo19.png
// module id = 861
// module chunks = 0